// app/javascript/controllers/popup_controller.js
import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["radioButton", "modal"];

  connect() {
    this.radioButtonTargets.forEach((radioButton) => {
      radioButton.addEventListener("change", (event) => {
        if (event.target.checked) {
          this.showPopup(event.target);
        }
      });
    });
  }

  showPopup(target) {
    const modalElement = this.modalTarget;
    const modal = new Modal(modalElement);
    const modalBody = modalElement.querySelector('.modal-body');

    modalBody.innerHTML = `You selected ${target.value}. For more information, visit <a href="https://example.com" target="_blank">this link</a>`;
    modal.show();
  }
}
